module.exports = __webpack_public_path__ + "fa20a51a2af3ed51307233182209754a.pdf";